import React from 'react'
import { PaperFoldBox } from '../Core/PaperFoldBox'
import { ReactComponent as Shield } from '../../assets/shield_empty.svg'
import FlexView from 'react-flexview/lib'

export const NoPoliciesCard = () => {
  return (
    <PaperFoldBox>
      <FlexView vAlignContent={'center'}>
        <Shield className="no-policy-shield" />
        <div className="text-title bolder gray margin-left-12">
          No Available Policies
        </div>
      </FlexView>
    </PaperFoldBox>
  )
}
